/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_RatingInputs */

const id_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat`)
};

const ms_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian`)
};

const da_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedømmelse`)
};

const de_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung`)
};

const en_us2_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const es_es2_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoración`)
};

const es_mx2_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación`)
};

const fil_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const fr_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const it_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione`)
};

const hu_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés`)
};

const nl_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beoordeling`)
};

const no_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vurdering`)
};

const pl_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena`)
};

const pt_br2_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const pt_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação`)
};

const ro_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare`)
};

const fi_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvosana`)
};

const sv_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betyg`)
};

const vi_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng`)
};

const tr_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puan`)
};

const cs_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení`)
};

const bg_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка`)
};

const ru_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка`)
};

const uk_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оцінка`)
};

const ar_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقييم`)
};

const hi_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेटिंग`)
};

const th_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน`)
};

const ja_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価`)
};

const zh_cn2_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const zh_hant1_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const ko_forms_review_rating = /** @type {(inputs: Forms_Review_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

/**
* | output |
* | --- |
* | "Rating" |
*
* @param {Forms_Review_RatingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_rating = /** @type {((inputs?: Forms_Review_RatingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_RatingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_rating(inputs)
	if (locale === "ms") return ms_forms_review_rating(inputs)
	if (locale === "da") return da_forms_review_rating(inputs)
	if (locale === "de") return de_forms_review_rating(inputs)
	if (locale === "en-US") return en_us2_forms_review_rating(inputs)
	if (locale === "es-ES") return es_es2_forms_review_rating(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_rating(inputs)
	if (locale === "fil") return fil_forms_review_rating(inputs)
	if (locale === "fr") return fr_forms_review_rating(inputs)
	if (locale === "it") return it_forms_review_rating(inputs)
	if (locale === "hu") return hu_forms_review_rating(inputs)
	if (locale === "nl") return nl_forms_review_rating(inputs)
	if (locale === "no") return no_forms_review_rating(inputs)
	if (locale === "pl") return pl_forms_review_rating(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_rating(inputs)
	if (locale === "pt") return pt_forms_review_rating(inputs)
	if (locale === "ro") return ro_forms_review_rating(inputs)
	if (locale === "fi") return fi_forms_review_rating(inputs)
	if (locale === "sv") return sv_forms_review_rating(inputs)
	if (locale === "vi") return vi_forms_review_rating(inputs)
	if (locale === "tr") return tr_forms_review_rating(inputs)
	if (locale === "cs") return cs_forms_review_rating(inputs)
	if (locale === "bg") return bg_forms_review_rating(inputs)
	if (locale === "ru") return ru_forms_review_rating(inputs)
	if (locale === "uk") return uk_forms_review_rating(inputs)
	if (locale === "ar") return ar_forms_review_rating(inputs)
	if (locale === "hi") return hi_forms_review_rating(inputs)
	if (locale === "th") return th_forms_review_rating(inputs)
	if (locale === "ja") return ja_forms_review_rating(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_rating(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_rating(inputs)
	return ko_forms_review_rating(inputs)
});
export { forms_review_rating as "forms.review.rating" }